var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSriLanka(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.001 44.522H0V467.477H0.001V256.001V44.522Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.999 511.998C397.383 511.998 511.998 397.383 511.998 255.999C511.998 114.615 397.383 0 255.999 0C114.615 0 0 114.615 0 255.999C0 397.383 114.615 511.998 255.999 511.998Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.349 44.522H111.714C107.786 47.207 103.942 50.002 100.175 52.895L77.9141 255.999L100.175 459.103C103.942 461.997 107.786 464.792 111.714 467.476H200.349V44.522Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000976562 256.001C0.000976562 338.746 39.269 412.308 100.175 459.105V52.896C39.269 99.694 0.000976562 173.256 0.000976562 256.001V256.001Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.826 156.064V162.469L412.064 162.505L411.826 156.064Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.595 322.782H443.362L422.957 345.043V389.565H378.435V367.304H400.696V322.782H300.522V350.608H278.261V297.577C271.431 291.463 267.131 282.582 267.131 272.695V128C267.131 109.559 282.081 94.609 300.522 94.609V300.522H345.044L360.32 287.791C357.652 281.436 356.174 274.457 356.174 267.131V233.74H322.783V166.958H389.565C389.565 155.828 406.261 144.697 406.261 144.697C406.261 144.697 422.957 155.827 422.957 166.958V183.654V233.741C435.34 233.888 455.014 233.567 476.269 233.741C470.685 223.981 467.478 212.4 467.478 200.35C467.478 180.709 475.958 163.051 489.456 150.831C470 107.716 438.954 70.954 400.287 44.522H233.74V467.478H400.288C447.307 435.337 483.056 387.926 500.4 332.388L491.595 322.782Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 511.999,
    height: 511.999,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSriLanka);
export default __webpack_public_path__ + "static/media/sriLanka.2d714b31de7f7d05d048f7c73bf5eefd.svg";
export { ForwardRef as ReactComponent };